export default __webpack_public_path__ + "static/1227-11cb362e1e04be3cec49376d89b55a09.gif";